import * as React from 'react';

import { createIcon } from '../Icon';
export const PauseIcon = createIcon(
  <React.Fragment>
    <rect x={6} y={4} width={4} height={16} />
    <rect x={14} y={4} width={4} height={16} />
  </React.Fragment>,
  'PauseIcon'
);
